async function fetchGalleryData(params) {
    const { endpoint, page, pageSize, search, filterA, filterB, headers = {}, country = '', } = params;
    const query = new URLSearchParams({
        page: String(page),
        pageSize: String(pageSize),
    });
    if (search)
        query.append('search', search);
    if (filterA)
        query.append('a', filterA);
    if (filterB)
        query.append('b', filterB);
    if (country) {
        query.append('country', country);
    }
    const response = await fetch(`${endpoint}?${query.toString()}`, {
        headers,
    });
    const json = await response.json();
    return {
        items: Array.isArray(json.items) ? json.items : [],
        totalItems: typeof json.totalItems === 'number' ? json.totalItems : 0,
    };
}

export { fetchGalleryData };
